import { call, put, takeEvery, select } from 'redux-saga/effects';
import { changeLeadProfile, updateLeadHistory } from '../../requests/change_lead_profile_request';
import { getLeadProfileWithRefs } from '../../requests/get_lead_profile_request';
import {
    getLeadProfileWithRefsRequestSuccess,
    getLeadProfileWithRefsRequestFailure,
} from '../actions/get_lead_profile_with_refs.actions';
import {
    changeRefBikeLeadRequestSuccess,
    changeRefBikeLeadRequestFailure,
} from '../actions/change_ref_bike_lead.actions';
import { CHANGE_REF_BIKE_LEAD_REQUEST } from '../constants/get_lead_profile.constants';
import { message_success, message_error } from '../../../../../components/Message';
import { getBlemishReportRequest } from '../actions/questions_actions/get_blemish_report.actions';

function* changeRefBikeLeadRequest({
    _id, key, value, lead_id,
}) {
    const { options, result } = yield call(changeLeadProfile, _id, key, value);

    if (result) {
        if (key === 'mileage') {
            const { Leads: { Lead_profile: { Ref_bike_lead: { bike_details: { mileage } } } } } = yield select();

            if (mileage !== value) {
                const action = `Purchasing agent changed mileage from ${mileage} to ${value}`;

                yield call(updateLeadHistory, { leadId: lead_id, action });
            }
        }

        if (key === 'written_off' || key === 'condition' || key === 'document_history' || key === 'non_runner') {
            yield put(getBlemishReportRequest(lead_id, 'rag_rating'));
        }

        if (/ref_bike_brand|ref_bike_model|ref_bike_variant/.test(key)) {
            const lead = yield call(getLeadProfileWithRefs, lead_id);
            lead.result
                ? yield put(getLeadProfileWithRefsRequestSuccess(lead.options.ref_bike_lead, key))
                : yield put(getLeadProfileWithRefsRequestFailure(lead.error));
        } else {
            yield put(changeRefBikeLeadRequestSuccess(key, options[key]));
        }

        message_success('Bike Details updated successfully!');
    } else {
        yield put(changeRefBikeLeadRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changeRefBikeLeadSaga() {
    yield takeEvery(CHANGE_REF_BIKE_LEAD_REQUEST, changeRefBikeLeadRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/change_ref_bike_lead.saga.js